import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../service/login.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  public show: boolean = false;
  public numeroDocumento: number;

  constructor(
    public router: Router,
    private authService: LoginService
  ) { }

  ngOnInit() {
  }

  showPassword() {
    this.show = !this.show;
  }

  onInputChange(event: any): void {
    const input = event.target.value;
    event.target.value = input.replace(/[^0-9]/g, '');
  }

  resetPassword() {
    this.authService.resetPassword(this.numeroDocumento).subscribe((resp) => {
      if (resp.isSuccess) {
        this.router.navigateByUrl('change-password/' + this.numeroDocumento)
      }
    })
  }
}